import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";

const FeatureForm = ({ mode, featureData, closeModal, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    image:"",
  });
  
  useEffect(() => {
    if (mode === "edit" && featureData) {
      setFormData(featureData);
    } else {
      setFormData({
        name: "",
        image:"",
      });
    }
  },[mode,featureData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      image: file, // simpan objek File, bukan path
    });
  };  

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (mode === "add") {
        const data = new FormData();
        data.append("name", formData.name);
        data.append("image", formData.image);

        const response = await axios.post(
          `${process.env.REACT_APP_API}/feature`,
          data,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
  
        if (response.status === 201) {
          showSuccess("Feature berhasil ditambahkan");
          closeModal();
          if (onSuccess) onSuccess();
        } else {
          showError("Gagal menambahkan feature");
        }

      } else {
        const updatedForm = new FormData();
        updatedForm.append("feature_id", formData.feature_id);
        updatedForm.append("name", formData.name);
        updatedForm.append("image_url", formData.image_url);

        if (formData.image instanceof File) {
          updatedForm.append("image", formData.image);
        }  

        // for (let pair of updatedForm.entries()) {
        //   console.log(pair[0] + ':', pair[1]);
        // }
  
        const response = await axios.put(
          `${process.env.REACT_APP_API}/feature/${formData.feature_id}`,
          updatedForm,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
  
        if (response.status === 200) {
          showSuccess("Feature berhasil diperbarui");
          closeModal();
          if (onSuccess) onSuccess();
        } else {
          showError("Gagal memperbarui feature");
        }
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menyimpan data.");
    }
  };

  return (        
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{mode === "add" ? "Tambah Feature" : "Edit Feature"}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div class="form-group mb-4">
            <label for="name" class="form-label">Nama Feature</label>
            <input 
              class="form-control"
              type="text" 
              name="name"
              placeholder="Isi Nama Feature"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div class="form-group mb-4">
            <label for="image" class="form-label">Image</label>
            <input
              type="file"
              className="form-control"
              id="image"
              name="image"
              onChange={handleFileChange}
              required={mode === "add"}
            />
          </div>

          <button type="submit" class="btn btn-primary">
            {mode === "add" ? "Save" : "Update"}
          </button>
        </form>
          
        </div>
      </div>
    </div>
  );
};

export default FeatureForm;
